import { useNavigate } from 'react-router-dom';
import useAuthStore from './authStore';
import { ROLES_ACTEUR, ROLES_DEMANDEUR } from '../constants/roles';

export const useDashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const allerDashboard = () => {
    const role = user?.roles?.[0]?.role || user?.role;
    if (user?.isGlobal || role === 'admin') navigate('/dashboard');
    else if (role === 'pdg') navigate('/parapheur');
    else if (ROLES_ACTEUR.includes(role)) navigate('/dashboard-acteur');
    else if (ROLES_DEMANDEUR.includes(role)) navigate('/dashboard-demandeur');
    else navigate('/dashboard');
  };

  return { allerDashboard };
};